import Link from 'next/link'
import React from 'react'
import { connect } from 'react-redux'

import { sendGTMData } from '../../utils/gtm'

const DisciplinaCard = ({ disciplina, paginaCorrente }) => {
  const defaultColor = 'black'
  const color = disciplina.color ? `#${disciplina.color}` : defaultColor

  const handleGTM = (itemTitle) => {
    const pages = ['discipline-all']
    if (itemTitle && pages.includes(paginaCorrente?.page?.chiave)) {
      sendGTMData({
        event: 'GAevent',
        eventID: '02',
        eventCategory: 'menu_vedi_tutti',
        eventAction: 'didattica',
        eventLabel: itemTitle.toGTMFormat(),
      })
    }
  }

  return (
    <Link legacyBehavior href={disciplina.url}>
      <a
        className="discipline-item"
        style={{ backgroundColor: color }}
        onClick={() => handleGTM(disciplina.titolo)}
      >
        <div className="discipline-item__title">{disciplina.titolo}</div>
        {/* <div className="discipline-item__details">
          <div className="discipline-item__details__title">{disciplina.titolo?.capitalize()}</div>
          <div className="discipline-item__details__abstract">{disciplina.descrizione}</div>
        </div> */}
      </a>
    </Link>
  )
}

const mapStateToProps = (state) => {
  return {
    paginaCorrente: state.paginaCorrente.paginaCorrente,
  }
}

export default connect(mapStateToProps, null)(DisciplinaCard)
